<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="113.531" height="132" viewBox="0 0 113.531 132">
    <g id="Gruppe_908" data-name="Gruppe 908" transform="translate(-911.734 -5310.903)">
      <g id="Gruppe_907" data-name="Gruppe 907">
        <path id="Icon_material-feedback" data-name="Icon material-feedback" d="M105.153,3H14.35A11.335,11.335,0,0,0,3.057,14.35L3,116.5,25.7,93.8h79.453a11.384,11.384,0,0,0,11.35-11.35V14.35A11.384,11.384,0,0,0,105.153,3Z" transform="translate(908.734 5308.14)" fill="#007656"/>
      </g>
      <text id="_" data-name="✓ " transform="translate(944.266 5310.903)" fill="#fff" font-size="70" font-family="SegoeUIEmoji, Segoe UI Emoji"><tspan x="0" y="76">✓</tspan><tspan y="76" font-family="SegoeUI, Segoe UI"> </tspan></text>
    </g>
  </svg>
</template>